import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import AnimatedOutlet from "./Animation/AnimatedOutlet";

const Layout: React.FC = () => {
  return (
    <div className="wrapper">
      <Header />
      <main>
        <AnimatedOutlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
